import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import style from './style.css';
//import FontAwesome from 'react-fontawesome';
import * as CardComponents from '../';
import Filters from '../../../../other/filters';
import cx from '../../../../styles';
import ImageLightbox from '../../../Common/ImageLightbox';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
import BlockUnblockUser from '../../BlockUnblockUser';

const CommentCardComponent = ({comment, imageThumbSize = "mini", siteUrl, cardName, match, status, userId, postId, topic, t}) => {
    const [showComment, setShowComment] = useState(true);
    const [showCover, setShowCover] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(()=>{
        if(comment.block_user && getUrlParameter('commentId') && getUrlParameter('commentId').length > 1 && comment.block_user.anonymous_status === 0 && comment.block_user.user_id === userId){
            setShowCover(true)
        }else if(comment.block_user){
            setShowComment(false)
        }
    },[])
    const onActionClick = () =>{
        setIsOpen(true)
    }
    const toggleModal = () => {
        setIsOpen(false)
    }

    const toggleReply = () => {
        setShowCover(false)
    }
    const { AuthorLink, LastSeen, ActionLink } = CardComponents;
    const author = comment.user;
    const lastSeen = comment.nice_time;
    const actions = comment.actions;
    const message = comment.is_sticker ? Filters.process(['stickerify'], comment.message) : comment.message;
    return(
        showComment &&
        <div className={cx("post-section", "comment-card-component", showCover?"cover":"")}>
            {
                showCover && 
                <div className={cx('block-comment-overlay-wrapper')}>
                    <p>{t('blocked_post')} <span onClick={onActionClick}>{t('here')}</span></p>
                </div>
            }
            {
                comment.block_user && showCover &&
                <BlockUnblockUser entityType={'profile'} entityId={author.id} status={0} id={comment.id} userName={author.fullname} userId={author.id} cardName={cardName} postId={postId} topic={topic} isOpen={isOpen} toggleModal={toggleModal} blockUser={false} toggleReply={toggleReply} blockReply={true}/>
            }
            <div className={cx("post-section-header")}>
                <AuthorLink id={author.id} slug={author.slug ? siteUrl + author.slug : ''} url={author.url} fullName={author.fullname}
                    tagLine={author.tagline} imageUrl={author.image} imageThumbSize={imageThumbSize} cardName={cardName} match={match}/>

                <div className={cx("right")}>
                    <LastSeen lastSeen={lastSeen} cardName={cardName} match={match}/>
                    {
                        status == 1 &&
                        <ActionLink actions={actions} cardName={cardName} match={match}/>
                    }
                    
                </div>
            </div>
            <div className={cx("post-section-body")}>
                <div className={cx("reply-text", "text-desc")}>
                    <p dangerouslySetInnerHTML={{__html: message}}></p>
                </div>

                {
                    comment.images && comment.images.length > 0 &&
                    <div className={cx("img-blur-wrap")}>
                        <div style={{backgroundImage:'url('+ comment.images[0].thumbnail +')'}}></div>
                        <ImageLightbox images={comment.images} type={comment.images[0].type} imageAltText={'Post reply image'} height="200" width="420" />
                    </div>
                }
            </div>
        </div>
    );

}

export default CommentCardComponent;
